// ======================================================================
// File Name       : KeyValueConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

const UNPUBLIC = 0;
const PUBLIC = 1;
export const PUBIC_STATUS = {
  UNPUBLIC,
  PUBLIC,
  TEXT: {
    [UNPUBLIC]: '非公開',
    [PUBLIC]: '公開',
  },
  LIST: [UNPUBLIC, PUBLIC],
};

const UNLIMIT = 0;
const LIMIT = 1;
export const PUBIC_TIME = {
  UNLIMIT,
  LIMIT,
  TEXT: {
    [UNLIMIT]: '無期限',
    [LIMIT]: '公開日指定',
  },
  LIST: [UNLIMIT, LIMIT],
};

const DEFAULT = 0;
const MANUAL = 1;
export const IMAGE_FILE_SELECT_TYPE = {
  DEFAULT,
  MANUAL,
  TEXT: {
    [DEFAULT]: 'デフォルト',
    [MANUAL]: '手動',
  },
  LIST: [DEFAULT, MANUAL],
};

const ADMIN = 0;
const GUARDIAN = 1;
const STUDENT = 2;
export const USER_TYPE = {
  ADMIN,
  GUARDIAN,
  STUDENT,
  TEXT: {
    [ADMIN]: '管理ユーザー',
    [STUDENT]: '受講ユーザー',
  },
  LIST: [STUDENT, GUARDIAN, ADMIN],
};

export const USER_ATTRIBUTE_KEY = [...Array(20)].reduce(
  (pre, cur, index) => {
    const num = index + 1;
    pre.TEXT[num] = ('0' + num).slice(-2);
    pre.LIST.push(num);
    return pre;
  },
  { TEXT: {}, LIST: [] }
);

export const REPORT_STATUS_NOT_SUBMITTED = 0;
export const REPORT_STATUS_SUBMITTED = 1;
export const REPORT_STATUS_CHECKING = 2;
export const REPORT_STATUS_REMAND = 3;
export const REPORT_STATUS_PENDING_APPROVAL = 4;
export const REPORT_STATUS_APPROVED = 5;
export const REPORT_STATUS_RESUTL_RETURNED = 6;
export const REPORT_STATUS = {
  REPORT_STATUS_NOT_SUBMITTED,
  REPORT_STATUS_SUBMITTED,
  REPORT_STATUS_CHECKING,
  REPORT_STATUS_REMAND,
  REPORT_STATUS_PENDING_APPROVAL,
  REPORT_STATUS_APPROVED,
  REPORT_STATUS_RESUTL_RETURNED,
  TEXT: {
    [REPORT_STATUS_NOT_SUBMITTED]: '未提出',
    [REPORT_STATUS_SUBMITTED]: '提出済み',
    [REPORT_STATUS_CHECKING]: '添削中',
    [REPORT_STATUS_REMAND]: '差し戻し',
    [REPORT_STATUS_PENDING_APPROVAL]: '承認待ち',
    [REPORT_STATUS_APPROVED]: '承認済み',
    [REPORT_STATUS_RESUTL_RETURNED]: '結果返却済み',
  },
};

export const REPORT_OPERATION_TYPE_APPROVE = 0;
export const REPORT_OPERATION_TYPE_REMAND = 1;
export const REPORT_OPERATION_TYPE_FORCED_RECOVERY = 2;
export const REPORT_OPERATION_TYPE_DISTRIBUTION = 3;
export const REPORT_OPERATION_TYPE_ACQUISITION = 4;
export const REPORT_OPERATION_TYPE_WITHDRAWAL = 5;
export const REPORT_OPERATION_TYPE_CORRECTION_COMPLETED = 6;
export const REPORT_OPERATION_TYPE_SAVE = 7;
export const REPORT_OPERATION_TYPE = {
  REPORT_OPERATION_TYPE_APPROVE,
  REPORT_OPERATION_TYPE_REMAND,
  REPORT_OPERATION_TYPE_FORCED_RECOVERY,
  REPORT_OPERATION_TYPE_DISTRIBUTION,
  REPORT_OPERATION_TYPE_ACQUISITION,
  REPORT_OPERATION_TYPE_WITHDRAWAL,
  REPORT_OPERATION_TYPE_CORRECTION_COMPLETED,
  REPORT_OPERATION_TYPE_SAVE,
  TEXT: {
    [REPORT_OPERATION_TYPE_APPROVE]: '承認',
    [REPORT_OPERATION_TYPE_REMAND]: '差し戻し',
    [REPORT_OPERATION_TYPE_FORCED_RECOVERY]: '強制回収',
    [REPORT_OPERATION_TYPE_DISTRIBUTION]: '分配',
    [REPORT_OPERATION_TYPE_ACQUISITION]: '取得',
    [REPORT_OPERATION_TYPE_WITHDRAWAL]: '取り下げ',
    [REPORT_OPERATION_TYPE_CORRECTION_COMPLETED]: '添削完了',
    [REPORT_OPERATION_TYPE_SAVE]: '保存',
  },
};
